import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ModalController} from 'ionic-angular';

import { WorkplanDetailsPage } from '../workplan-details/workplan-details';
import { WorkplanUserPage } from '../workplan-user/workplan-user';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { Settings } from '../../settings';

import * as moment from 'moment';
import 'moment/locale/de';

import { PopoverController } from 'ionic-angular';

/**
 * Generated class for the WorkplanPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-workplan',
    templateUrl: 'workplan.html',
})
export class WorkplanPage {

    title: string = 'Wocheneinsatzplan';
    tab: string;
    results: any;
    workplan: any;
    week: number = 0;
    otherUsers: any;
    userPayload: any;
    projectManagerName: string = Settings.projectManagerName;

    projectCreatorName: string = Settings.projectCreatorName;
    showProjectCreator = Settings.showProjectCreator;

    constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public modalCtrl: ModalController, public popoverCtrl: PopoverController, public teamappProvider: TeamappProvider) {

        if(this.navParams.get("title")) {
            this.title = this.navParams.get("title");
        }

        if(this.navParams.get("user_payload")) {
            this.userPayload = this.navParams.get("user_payload");
            this.teamappProvider.http_request('user_payload='+this.userPayload.secret, 'workplan', false).then(data => {
                this.results = data;
                this.loadActualWeek();
                this.loadUserPermissions();
            });
        } else {
            this.teamappProvider.http_request('', 'workplan', false).then(data => {
                this.results = data;
                this.loadActualWeek();
                this.loadUserPermissions();
            });
        }

    }

    loadActualWeek() {
        this.week = this.getWeekNumber();
        let actWorkPlan = this.loadWorkPlanForWeek(this.week);
        if(actWorkPlan !== false) {
            this.workplan = actWorkPlan;
        } else {
            return false;
        }
    }

    nextWeek() {
        if((this.week + 1) <= this.getAllWeeksOfYear()) {
            this.week = this.week + 1;
            this.workplan = this.loadWorkPlanForWeek(this.week);
        }
    }

    previousWeek() {
        if((this.week - 1) >= 1) {
            this.week = this.week - 1;
            this.workplan = this.loadWorkPlanForWeek(this.week);
        }
    }

    loadWorkPlanForWeek(week: number) {
        for(let i = 0; i<this.results.length; i++){
            if(this.results[i].weeknumber == week) {
                return this.results[i];
            }
        }
        return false;
    }

    refreshWorkPlans(refresher: any) {
        setTimeout(() => {
            refresher.complete();
        }, 2000);
    }

    openWorkPlan(plan: any) {
        let profileModal = this.modalCtrl.create(WorkplanDetailsPage,{data: plan});
        profileModal.present();
    }

    getWeekNumber() {
        return moment().isoWeek();
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad WorkplanPage');
    }

    getAllWeeksOfYear() {
        return moment().isoWeeksInYear();
    }

    getYear() {
        return moment().isoWeekYear();
    }

    loadUserPermissions() {
        this.teamappProvider.http_request('', 'workplanuser', false, false).then(data => {
            this.otherUsers = data;
        });
    }

    showUserList(myEvent) {
        const popover = this.popoverCtrl.create(WorkplanUserPage, {user: this.otherUsers}, {cssClass: 'user-popover-list'});
        popover.present({
            ev: myEvent
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/workplan/workplan.ts